import React from "react";
// @ts-ignore
import pdf from "@assets/images/hexpert/pdf.png";
import {Document} from "../../components/Document";
import { HexpertResultLink } from "../../types/hexpertResultTypes";

type WeFitDocumentBlockProps = {
  links: HexpertResultLink[];
  title?: string;
};

export const WeFitDocumentBlock = ({ links, title }: WeFitDocumentBlockProps) => {
  return (
    <div className={"c-hex-documents-container"}>
      <h3 className="c-hex-documents-header">{title}</h3>
      <hr className="c-hex-documents-divider" />
      <div className="c-hex-documents-text-wrapper">
        {links.map((link) => (
          <Document name={link.LinkName} url={link.Url} icon={pdf} />
        ))}
      </div>
    </div>
  );
};
